export enum FirebaseCollections {
  MEMBER_POSTS = 'memberPosts',
  NEWS_NOTIFICATIONS = 'newsNotifications',
  NEWS_NOTIFICATION_STATE = 'newsNotificationState',
  USERS = 'users',
  INVITATIONS = 'invitations',
  PASSWORD_RESETS = 'passwordResets',
  NEWSLETTERS = 'newsletters',
}
